import { render } from "./chat_loader.vue?vue&type=template&id=14efbb18"
const script = {}

import "./chat_loader.vue?vue&type=style&index=0&id=14efbb18&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__